/* wbpk-import import React from 'react'; */
/* wbpk-import import ICAppDataScope from '../icapp/ICAppDataScope'; */
/* wbpk-import import { isEmpty, redirect } from '../icapp/ICAppUtils'; */
/* wbpk-import import '../vendor/jquery.hammer.js'; */
/* wbpk-import import ICAppApi from '../icapp/ICAppApi'; */
/* wbpk-import import UserApi from '../endpoints/UserApi'; */
/* wbpk-import import LocalStorageHelper from './LocalStorageHelper'; */
/* wbpk-import import MobileAppLinksWidget from '../widgets/MobileAppLinksWidget'; */
/* wbpk-import import SidebarMenu from '../../components/layout/SidebarMenu'; */
/* wbpk-import import BrandingHelper from './BrandingHelper'; */

/* wbpk-export-def-class export default  */ class CommonHelper {
    static build_side_menu(has_platform_access = null, initResult) {
        const SideMenuScope = ICAppDataScope.getScope('SideMenu');
        const menu_items = SideMenuScope.getAll();
        const items = [];

        for (const id in menu_items) {
            items.push(menu_items[id]);
        }

        if (typeof ReactDOM !== 'undefined' && typeof SidebarMenu !== 'undefined' && $('#sidebar-scroll .sidebar-content').length > 0) {
            ReactDOM.render(
                <SidebarMenu has_platform_access={has_platform_access} items={items} initResult={initResult}/>,
                $('#sidebar-scroll .sidebar-content')[0]
            );
        }
    }

    static build_dropdown_menu() {
        // console.log('build_dropdown_menu');
        const DropdownMenuScope = ICAppDataScope.getScope('DropdownMenu');
        const dropdown = $('.dropdown-menu-right').hammer();
        dropdown.html('');
        const menu_items = DropdownMenuScope.getAll();
        for (const menu_item_id in menu_items) {
            const menu_item = menu_items[menu_item_id];
            const $menu_item = $('<li>', {
                'class': menu_item.class
            }).hammer();
            if (menu_item.onclick) {
                const $menu_item_content = $('<a>', {
                    onclick: menu_item.onclick,
                    href: 'javascript:void(0);'
                });
                if (menu_item.icon) {
                    $menu_item_content.append($('<i>', {
                        'class': menu_item.icon
                    }));
                }
                if (menu_item.strong) {
                    $menu_item_content.append($(menu_item.title));
                } else {
                    $menu_item_content.append($('<strong>' + menu_item.title + '</strong>'));
                }
                $menu_item.append($menu_item_content);
            } else if (menu_item.url) {
                const $menu_item_content = $('<a>', {
                    href: menu_item.url
                });
                if (menu_item.strong) {
                    $menu_item_content.html('<strong>' + menu_item.title + '</strong>');
                } else {
                    $menu_item_content.html(menu_item.title);
                }
                $menu_item.append($menu_item_content);
            } else {
                if (menu_item.strong) {
                    $menu_item.html('<strong>' + menu_item.title + '</strong>');
                } else {
                    $menu_item.html(menu_item.title);
                }
            }
            dropdown.append($menu_item);
        }
    }

    static build_mobile_app_links(links) {
        const $mobile_app_sidebar_place = $('#sidebar-mobile-apps');
        if (typeof ReactDOM === 'undefined' || typeof MobileAppLinksWidget === 'undefined' || $mobile_app_sidebar_place.length === 0) return;
        ReactDOM.render(
            <MobileAppLinksWidget links={links}/>,
            $mobile_app_sidebar_place[0]
        );
    }

    static logout(referrer = null, email = null) {
        console.log('logout');
        ICAppApi.closeWS();

        UserApi.logout().then(result => {
            if (result === true) {
                // LocalStorageHelper.removeItem('login');
                // LocalStorageHelper.removeItem('hash');
                LocalStorageHelper.removeItem('user_filter');
                LocalStorageHelper.removeItem('section');
                PLATFORM_APP.removeCredentials(() => {
                    console.log('Login credentials removed');
                    let redirectUrl = 'login.html?v=' + current_app_version;
                    if (!!referrer && typeof (referrer) === 'string') {
                        redirectUrl += '&referrer=' + encodeURIComponent(referrer);
                    }
                    if (!!email && typeof (email) === 'string') {
                        redirectUrl += '&email=' + encodeURIComponent(email);
                    }
                    redirect(redirectUrl);
                });
                // redirect('login.html?v=' + current_app_version);
            } else {
                console.error('logout failed: ' + result);
                PLATFORM_APP.redirect('index.html?v=' + current_app_version);
            }
        });
    }

    static back_to_admin_profile() {
        console.log('back_to_admin_profile');

        ICAppApi.call('POST', 'user-api/back-to-admin-profile', {}, result => {
            if (result === true) {
                if (LocalStorageHelper.getItem('section') !== '') {
                    redirect(LocalStorageHelper.getItem('section'));
                } else {
                    redirect('new-users.html');
                }

            } else {
                console.error('back_to_admin_profile failed: ' + result);
            }
        }, {});
    }

    /**
     * Initializes chatra (online chat)
     * @param user
     * @param visitor_info
     */
    static chatra(user = null, visitor_info = null) {
        if (user === null || user.user_uid === null || visitor_info === null) {
            return;
        }

        window.ChatraSetup = {
            /* current user’s generated string */
            clientId: user.user_uid,
            disabledOnMobile: false,
            startHidden: true,
        };

        (function (d, w, c) {
            w.ChatraID = 'uJemDGHXLfo7q3BJ2';
            let s = d.createElement('script');
            w[c] = w[c] || function () {
                (w[c].q = w[c].q || []).push(arguments);
            };
            s.async = true;
            s.src = 'https:' //(d.location.protocol === 'https:' ? 'https:' : 'http:')
                + '//call.chatra.io/chatra.js';
            if (d.head) d.head.appendChild(s);
        })(document, window, 'Chatra');

        Chatra('updateIntegrationData', visitor_info);
    }


    static openSupportChat() {
        if(!window.Chatra) {
            return;
        }

        window.Chatra('show');
        window.Chatra('openChat', true);

        let mutationObserver = new MutationObserver(function (mutations, observe) {
            if ((typeof mutations[0] !== 'undefined') && (typeof mutations[0].target !== 'undefined') && !mutations[0].target.classList.contains('chatra--expanded')) {
                observe.disconnect();
                window.Chatra('hide');
            }
        });

        mutationObserver.observe(document.querySelector('#chatra'), {
            attributeFilter: ['class']
        });
    }

    static findGetParameter(parameterName, default_value = '') {
        let result = default_value;
        let tmp = [];
        const items = location.search.substr(1).split("&");
        for (let index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName) {
                result = decodeURIComponent(tmp[1].replace(/\+/g, '%20'));
                break;
            }
        }
        return result;
    }

    /**
     *
     * @returns {object} //an object with param as property, param value as property value. e.g. { action: "edit", member_uid: "UID_HERE" }
     */
    static getAllGetParameters () {
        let result = {};
        const items = location.search.substr(1).split("&");
        for (let i = 0; i < items.length; i++) {
            let keyValue = items[i].split("=");
            result[keyValue[0]] = keyValue[1];
        }
        return result;
    }

    static _requiredVariable(name) {
        throw new Error(name + ' is required');
    }

    static addRecent(type = CommonHelper._requiredVariable('type'), id = CommonHelper._requiredVariable('id'), data = {}) {
        ICAppDataScope.getScope('Recent').clear();
        ICAppApi.call('POST', 'user-data/add-recent', {
            type: type,
            id: id,
            data: data
        }, (data, cbParams) => {
        }, {});
    }

    static applyBranding(brand) {
        if (brand) {
            BrandingHelper.specifyDocumentElementForWlProject();
            if (!!brand.customCss) {
                BrandingHelper.injectStyles(brand.customCss);
            }

            if (brand.login) {
                const {logo, logoAlt, centeredLogo, logoWidth, logoHeight} = brand.login;
                BrandingHelper.logo(APP_URL + '/' + logo, logoAlt, centeredLogo, logoWidth, logoHeight, brand.hostname);
                if (brand.login.hideMenu) {
                    BrandingHelper.loginMenu();
                }
                if (brand.login.hideSecurityMessage) {
                    BrandingHelper.loginSecurityMessage();
                }
                if (brand.login.hideCopyrights) {
                    BrandingHelper.loginRights();
                }
            }

            if (brand.teamJoin) {
                BrandingHelper.teamJoinPage(brand);
            }

            window.isBranded = true;
            if (brand.isSharenSplitTeam) {
                window.isSharenSplitTeam = brand.isSharenSplitTeam === true;
            }
        }

        setTimeout(() => {
            document.body.classList.remove('hide'); // TODO: remove this line after fully migrated to webpack
            document.getElementById('page-container')?.classList.remove('hide');
            document.dispatchEvent(new CustomEvent('ICAppApiInitBodyShown', { detail: null }));
        }, 250);
    }

    static createAvatarNotification(type, data) {
        switch (type) {
            case 'member':
                let member_avatar = <img src={data.member_avatar}/>;
                if (data.member_avatar === null) {
                    let avatar = data.member_name.split(' ');
                    if (avatar.hasOwnProperty("1") && avatar[1] !== "") {
                        member_avatar = <div
                            className="letter-member">{avatar[0].charAt(0).toUpperCase() + avatar[1].charAt(0)}</div>
                    } else {
                        member_avatar = <div
                            className="letter-member">{avatar[0].charAt(0).toUpperCase() + avatar[0].charAt(1)}</div>
                    }
                }
                return member_avatar;

            case 'team':
                let team_avatar = <img src={data.team_avatar}/>;
                if (data.team_avatar === null) {
                    let avatar = data.team_name.split(' ');
                    if (avatar.hasOwnProperty("1") && avatar[1] !== "") {
                        team_avatar =
                            <div className="letter-team">{avatar[0].charAt(0).toUpperCase() + avatar[1].charAt(0)}</div>
                    } else {
                        team_avatar =
                            <div className="letter-team">{avatar[0].charAt(0).toUpperCase() + avatar[0].charAt(1)}</div>
                    }
                }
                return team_avatar;

            case 'old_team':
                let old_team_avatar = <img src={data.old_team.avatar}/>;
                if (data.old_team.avatar === null) {
                    let avatar = data.old_team.name.split(' ');
                    if (avatar.hasOwnProperty("1") && avatar[1] !== "") {
                        old_team_avatar = <div
                            className="letter-oldteam">{avatar[0].charAt(0).toUpperCase() + avatar[1].charAt(0)}</div>
                    } else {
                        old_team_avatar = <div
                            className="letter-oldteam">{avatar[0].charAt(0).toUpperCase() + avatar[0].charAt(1)}</div>
                    }
                }
                return old_team_avatar;
        }
    }

    static createAccountAvatar(avatar, account, class_name, noimg_class_name = "no-image") {
        let ret_avatar = <img src={PLATFORM_APP.maybeAddURLProtocol(avatar)} className={class_name}/>;
        if (typeof avatar === 'undefined' || avatar === null || avatar === '') {
            let letter = '';
            let field = '';
            if (account.hasOwnProperty('name') && account.name !== '') {
                field = account.name;
            }

            if (account.hasOwnProperty('full_name') && account.full_name !== '') {
                field = account.full_name;
            }

            if (!isEmpty(field)) {
                let _name = field.split(' ');
                if (_name.hasOwnProperty("1") && _name[1] !== "") {
                    letter = _name[0].charAt(0).toUpperCase() + _name[1].charAt(0);
                } else {
                    letter = _name[0].charAt(0).toUpperCase() + _name[0].charAt(1);
                }
                ret_avatar = <div className="letter-avatar">{letter}</div>;
            } else {
                if (!isEmpty(account.email)) {
                    letter = account.email.charAt(0).toUpperCase() + account.email.charAt(1);
                    ret_avatar = <div className="letter-avatar">{letter}</div>;
                } else {
                    ret_avatar = <img src="img/property_no_photo.png" className={noimg_class_name}/>
                }
            }
        }

        return ret_avatar;
    }

    /**
     * Mimicking PHP's explode() function (JS's split() works differently with limit)
     * @param {String} delimiter
     * @param {String} str
     * @param {int} [limit]
     * @returns {Array}
     */
    static explode(delimiter, str, limit) {
        let result = str.split(delimiter);
        if (limit < 0) {
            result.splice(limit, -limit);
        }
        if (limit > 0 && limit < result.length) {
            let tail = result.splice(limit - 1);
            result.push(tail.join(delimiter));
        }
        if (limit === 0) {
            result = [str];
        }
        return result;
    }

    /**
     * Mimicking PHP's StringHelper::explodeFromTheEnd() function
     * @param {String} delimiter
     * @param {String} str
     * @param {int} [limit]
     * @returns {Array}
     */
    static explodeFromTheEnd(delimiter, str, limit) {
        let result = str.split(delimiter);
        if (limit < 0) {
            result.splice(0, -limit);
        }
        if (limit > 0 && limit < result.length) {
            let head = result.splice(0, result.length - limit + 1);
            result.unshift(head.join(delimiter));
        }
        if (limit === 0) {
            result = [str];
        }
        return result;
    }

    static createFunctionWithTimeout(callback, timeout = 1000) {
        let called = false;
        const fn = () => {
            if (!called) {
                called = true;
                callback();
            }
        };
        setTimeout(fn, timeout);
        return fn;
    }

    /**
     * For safe extracting deep-nested object properties
     * Usage: CommonHelper.safeGet(['a', 'b', 'c', 'd'], from) returns from.a.b.c.d or null if it doesn't exists
     * @param {Array} path
     * @param {Object} object
     * @returns {*}
     * @deprecated Use optional chaining (?.) instead. It is now correctly transpiled
     */
    static safeGet(path, object) {
        return path.reduce((carry, property) => (carry && carry.hasOwnProperty(property)) ? carry[property] : null, object)
    }

    static readableFileSize(size) {
        if (!size) {
            return null;
        }
        let val = size;
        let dim = 'B';
        const kb = size / 1000;
        if (kb >= 1) {
            dim = 'Kb';
            if (kb < 1000) {
                val = Math.round(kb);
            } else {
                const mb = kb / 1000;
                val = Number((mb).toFixed(1));
                dim = 'Mb';
            }
        }
        return `${val} ${dim}`;
    }

    /**
     * Return true if all properties of A strictly equal to the same properties of B
     *
     * If values are objects themselves compares recursively (up to maxDepth level)
     *
     * @param {Object} objA
     * @param {Object} objB
     * @param {boolean} compareLength if true then the key counts must also equal (that is, A shallowly equals B)
     * @param {int} [maxDepth]
     * @returns {boolean}
     */
    static compareObjects(objA, objB, compareLength, maxDepth) {
        if (!maxDepth) {
            //by default, we dive into Object-type property up to 5 levels deep.
            //we shouldn't dive endlessly as there could be loops when e.g. objA is the property of itself
            //(or more complicated cases)
            maxDepth = 5;
        }

        if (objA === objB) {
            return true;
        }

        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
            return false;
        }

        const keysA = Object.keys(objA);
        if (compareLength && keysA.length !== Object.keys(objB).length) {
            return false;
        }

        // Test for A's keys different from B.
        for (let i = 0; i < keysA.length; i++) {

            if (!objB.hasOwnProperty(keysA[i])) {
                return false;
            }
            if (typeof objA[keysA[i]] === 'object' && typeof objB[keysA[i]] === 'object') {
                if (maxDepth <= 1 || !this.compareObjects(objA[keysA[i]], objB[keysA[i]], compareLength, maxDepth - 1)) {
                    return false;
                }
            } else if (objA[keysA[i]] !== objB[keysA[i]]) {
                return false;
            }
        }

        return true;
    }

    /**
     * Escapes special characters to allow using string as part of regular expression
     *
     * @param string
     * @returns {string}
     */
    static escapeRegExp = string => string.replace(/[.*+?^${}()#|[\]\\]/g, '\\$&');

    /**
     * Determines user location, IP, and timezone data
     *
     * @param callback
     */
    static geoLocation(callback) {
        const GOOGLE_CLOUD_GET_LOCATION_URL = 'https://us-central1-airgms-prod.cloudfunctions.net/ipinfo';
        const IPINFO_URL = 'https://ipinfo.io/json';

        const sendResponse = (url, result) => {
            let formattedResult = {
                ip: null,
                country: null,
                countryCode: null,
                region: null,
                regionCode: null,
                city: null,
                timezone: null,
                lat: null,
                lng: null,
            };
            if (result === null) {
                return formattedResult;
            }
            if (url === GOOGLE_CLOUD_GET_LOCATION_URL) {
                formattedResult.ip = result.ip;
                formattedResult.country = result.country;
                formattedResult.regionCode = result.region;
                formattedResult.city = result.city;

                const latLng = result.cityLatLong ? result.cityLatLong.split(',') : [];
                if (latLng.length === 2) {
                    formattedResult.lat = parseFloat(latLng[0]);
                    formattedResult.lng = parseFloat(latLng[1]);
                }

                if (result.cityData && Array.isArray(result.cityData) && result.cityData.length > 0) {
                    const city = result.cityData[0];
                    formattedResult.countryCode = city.iso2;
                    formattedResult.region = city.province;
                    formattedResult.timezone = city.timezone;
                    formattedResult.lat = city.lat;
                    formattedResult.lng = city.lng;
                }
            }
            if (url === IPINFO_URL) {
                formattedResult.ip = result.ip;
                formattedResult.countryCode = result.country;
                formattedResult.region = result.region;
                formattedResult.city = result.city;
                formattedResult.timezone = result.timezone;

                const latLng = result.loc ? result.loc.split(',') : [];
                if (latLng.length === 2) {
                    formattedResult.lat = parseFloat(latLng[0]);
                    formattedResult.lng = parseFloat(latLng[1]);
                }
            }
            callback(formattedResult);
        };

        const fetchLocation = (url, onSuccess, onError) => {
            fetch(url)
                .then(response => response.json())
                .then(result => onSuccess(result), error => onError(error));
        };

        const googleLocation = (onSuccess, onError) => {
            fetchLocation(GOOGLE_CLOUD_GET_LOCATION_URL, onSuccess, onError);
        };

        const ipinfoLocation = (onSuccess, onError) => {
            fetchLocation(IPINFO_URL, onSuccess, onError);
        };

        googleLocation(result => {
            if (!result || result.city === '?') {
                ipinfoLocation(result => sendResponse(IPINFO_URL, result), () => sendResponse(IPINFO_URL, null))
            } else {
                sendResponse(GOOGLE_CLOUD_GET_LOCATION_URL, result);
            }
        }, () => {
            ipinfoLocation(result => sendResponse(IPINFO_URL, result), () => sendResponse(IPINFO_URL, null))
        });
    }

    /**
     * Returns string with upper cased first char
     *
     * @param {string} str
     *
     * @returns {string}
     */
    static ucFirst(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

  /**
   * Validate Domain
   * @param {String} domain
   * @param {Boolean} allowEmpty
   * @returns {Boolean}
   */
  static validateDomain(domain, allowEmpty = false) {
    return (allowEmpty && isEmpty(domain))
      || (domain.length <= 253 && /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z][a-z0-9-]{0,61}[a-z0-9]$/i.test(domain));
  }

  /**
   * Validate Email
   * @param {String} email
   * @param {Boolean} allowEmpty
   * @returns {Boolean}
   */
  static validateEmail(email, allowEmpty = false) {
    return (allowEmpty && isEmpty(email))
      || /^((([a-z]|\d|[!#$%&'*+\-\/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-\/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((([\x20\x09]*(\x0d\x0a))?[\x20\x09]+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(([\x20\x09]*(\x0d\x0a))?[\x20\x09]+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
  }

    /**
     * Sorts array in groups using multiple group conditions
     *
     * Example:
     * CommonHelper.sortByGroups(
     *   [1,2,3,4,5,6,7,8,9,10],
     *   value => value % 2 === 0,
     *   value => value % 3 === 0
     * )
     *
     * Output: [6, 2, 4, 8, 10, 3, 9, 1, 5, 7]
     * Here are four parts:
     *   0: [6]             - divides by 2 and 3
     *   1: [2, 4, 8, 10]   - divides by 2, not divides by 3
     *   2: [3, 9]          - not divides by 2, divides by 3
     *   3: [1, 5, 7]       - not divides by 2, not divides by 3
     *
     * @param {any[]} array
     * @param {...function} positionConditions
     * @returns {any[]}
     */
    static sortByGroups(array, ...positionConditions) {
        let arrayParts = [...Array(positionConditions.length ** 2)].map(() => []);
        positionConditions.reverse();
        array.forEach(value => {
            let arrayPartsKey = 0;
            positionConditions.forEach((condition, index) => {
                arrayPartsKey += (!condition(value) ? 2 ** index : 0);
            });
            arrayParts[arrayPartsKey].push(value);
        });
        return arrayParts.flat();
    }

    /**
     * Mailto link click emulation
     *
     * @param {string} to
     * @param {?string} [subject]
     * @param {?string} [target]
     */
    static openEmailClient(to, subject = '', target = '_blank') {
        const mail = document.createElement('a');
        mail.href = `mailto:${to}?subject=${subject}`;
        mail.target = target;
        mail.click();
    }

    /**
     * Converts float to readable format
     * 1234.670000001 => 1,234.67
     *
     * @param {number} value
     * @param {number} fractionDigits
     * @return {string}
     */
    static digitize(value, fractionDigits = 2) {
      let parts = Number(value).toFixed(fractionDigits).split('.');
      let sign = '';

      if (value < 0) {
        sign = '-';
        parts[0] = parts[0].slice(1);
      }

        return sign + parts[0] // Wow
            .split('')
            .reverse()
            .join('')
            .match(/.{1,3}/g)
            .join(',')
            .split('')
            .reverse()
            .join('') + (parts[1] ? ('.' + parts[1]) : '');
    }

    /** Checks if reservation is an active one
     *@param {string} status
     */
    static isReservationActive (status)
    {
        return ['Accepted','Pending','Being verified by Airbnb','Awaiting Payment'].includes(status);
    }

    /** Checks if Airbnb room element is a bedroom or not
     *
     * @param {object} element
     */
    static isAirbnbBedroom (element)
    {
        return element.title.substring(0, 7).toLowerCase() === 'bedroom' || element.title === 'Common_spaces';
    }
}
